import Cookies from 'js-cookie';

import { getRootDomain } from './get-root-domain';

export const JWT_KEY = 'dbs-web-token';
export const REFRESH_TOKEN_KEY = 'dbs-refresh-token';

export function setJwt(token: string): void {
  Cookies.set(JWT_KEY, token, { domain: getRootDomain() });
}

export function setRefreshToken(token: string): void {
  Cookies.set(REFRESH_TOKEN_KEY, token, { domain: getRootDomain() });
}

export function getJwt(): string | undefined {
  return Cookies.get(JWT_KEY);
}

export function getRefreshToken(): string | undefined {
  return Cookies.get(REFRESH_TOKEN_KEY);
}

export function clearJwt(): void {
  Cookies.remove(JWT_KEY, { domain: getRootDomain() });
}

export function clearRefreshToken(): void {
  Cookies.remove(REFRESH_TOKEN_KEY, { domain: getRootDomain() });
}

export async function clearTokens(): Promise<void> {
  clearJwt();
  clearRefreshToken();
}
